module.exports = __webpack_public_path__ + "img/magnifyingglass.abd21f25.svg";